module.exports = __webpack_public_path__ + "img/Вальгусная деформация большого пальца стопы (или Hallux valgus).b5be4115.jpg";